import { useEffect } from "react";
export function useMultiSelectListboxMultiselectable(
  id: string | undefined,
  opened: boolean
) {
  useEffect(() => {
    if (!id || !opened) return;

    const selector = `.${id}-listbox-popup ul[role="listbox"]`;
    const apply = () => {
      const listbox = document.querySelector<HTMLElement>(selector);
      if (listbox && listbox.getAttribute("aria-multiselectable") !== "true") {
        listbox.setAttribute("aria-multiselectable", "true");
      }
    };

    apply();
    const observer = new MutationObserver(apply);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [id, opened]);
}
